import { useEffect, useState } from "react";
import firebase from "./config";
import EmailCard from "./EmailSingola";

const todoRef = firebase.database().ref("email/");

export default function Email(params) {
  const [info, setInfo] = useState([]);
  useEffect(() => {
    todoRef.on("value", function (snapshot) {
      const obj = snapshot.val();
      setInfo(Object.values(obj));
    });
  }, []);

  return (
    <div>
      {info
        .slice(0)
        .reverse()
        .map((e) => {
          return (
            <EmailCard
              nome={e.nome}
              oggetto={e.oggetto}
              testo={e.testo}
              email={e.email}
            />
          );
        })}
    </div>
  );
}
